import { apiHelper, sharedHelper, sessionHelper } from '@/utils'
import { API } from '@/constants'

export const staffService = {
    getAllStaffs,
    createStaff,
    getStaff,
    updateStaff,
    updateStaffStatus,
    unlockStaff,
    updateStaffProfile,
    getStaffProfile
};

const MODULE = {
    STAFF: 'company-staffs',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllStaffs(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    if (sessionHelper.getUserType == "STAFF") {
        requestOptions.params['location'] = sessionHelper.getStaffLocationUUID()
    }

    return apiHelper(API_URL).get(`/${MODULE.STAFF}`, requestOptions)
}


export function updateStaffStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.STAFF}/${data.id}`, requestOptions)
}

export function getStaff(id) {
    return apiHelper(API_URL).get(`/${MODULE.STAFF}/show/${id}`)
}

export function getStaffProfile() {
    return apiHelper(API_URL).get(`/${MODULE.STAFF}/profile`)
}

export function updateStaff(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'location_uuid', data.locationID);
    sharedHelper.appendIfNotNull(formData, 'title', data.title);
    sharedHelper.appendIfNotNull(formData, 'phone_code', data.phoneCode);
    sharedHelper.appendIfNotNull(formData, 'phone_iso', data.phoneISO);
    sharedHelper.appendIfNotNull(formData, 'phone', data.phone);
    sharedHelper.appendIfNotNull(formData, 'address_1', data.address1);
    sharedHelper.appendIfNotNull(formData, 'postcode', data.postcode);
    sharedHelper.appendIfNotNull(formData, 'state', data.state);
    sharedHelper.appendIfNotNull(formData, 'city', data.city);
    sharedHelper.appendIfNotNull(formData, 'calendar_color', data.calendarColor);
    sharedHelper.appendIfNotNull(formData, 'remark', data.remark);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_first_name', data.emergencyContactPersonFirstName);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_last_name', data.emergencyContactPersonLastName);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_phone', data.emergencyContactPersonPhone);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_phone_code', data.emergencyContactPersonCode);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_phone_iso', data.emergencyContactPersonCodeISO);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_address_1', data.emergencyContactPersonAddress1);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_postcode', data.emergencyContactPersonPostcode);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_city', data.emergencyContactPersonCity);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_state', data.emergencyContactPersonState);
    sharedHelper.appendIfNotNull(formData, 'date_join', data.dateJoin);
    sharedHelper.appendIfNotNull(formData, 'salary', data.salary);
    sharedHelper.appendIfNotNull(formData, 'birthday', data.birthday);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_email', data.emergencyContactPersonEmail);
    formData.append('_method', 'PUT');

    if (data.displayImage instanceof File) {
        formData.append('display_image', data.displayImage);
    }

    return apiHelper(API_URL).post(`/${MODULE.STAFF}/${data.id}`, formData)
}

export function unlockStaff(id) {
    return apiHelper(API_URL).patch(`/${MODULE.STAFF}/${id}/unlock`)
}

export function createStaff(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'location_uuid', data.locationID);
    sharedHelper.appendIfNotNull(formData, 'title', data.title);
    sharedHelper.appendIfNotNull(formData, 'first_name', data.firstName);
    sharedHelper.appendIfNotNull(formData, 'last_name', data.lastName);
    sharedHelper.appendIfNotNull(formData, 'email', data.email);
    sharedHelper.appendIfNotNull(formData, 'phone_code', data.phoneCode);
    sharedHelper.appendIfNotNull(formData, 'phone_iso', data.phoneISO);
    sharedHelper.appendIfNotNull(formData, 'phone', data.phone);
    sharedHelper.appendIfNotNull(formData, 'address_1', data.address1);
    sharedHelper.appendIfNotNull(formData, 'postcode', data.postcode);
    sharedHelper.appendIfNotNull(formData, 'state', data.state);
    sharedHelper.appendIfNotNull(formData, 'city', data.city);
    sharedHelper.appendIfNotNull(formData, 'calendar_color', data.calendarColor);
    sharedHelper.appendIfNotNull(formData, 'remark', data.remark);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_first_name', data.emergencyContactPersonFirstName);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_last_name', data.emergencyContactPersonLastName);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_phone', data.emergencyContactPersonPhone);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_phone_code', data.emergencyContactPersonCode);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_phone_iso', data.emergencyContactPersonCodeISO);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_address_1', data.emergencyContactPersonAddress1);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_postcode', data.emergencyContactPersonPostcode);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_city', data.emergencyContactPersonCity);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_state', data.emergencyContactPersonState);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_email', data.emergencyContactPersonEmail);
    sharedHelper.appendIfNotNull(formData, 'date_join', data.dateJoin);
    sharedHelper.appendIfNotNull(formData, 'birthday', data.birthday);
    sharedHelper.appendIfNotNull(formData, 'salary', data.salary);

    if (data.displayImage instanceof File) {
        formData.append('display_image', data.displayImage);
    }

    return apiHelper(API_URL).post(`/${MODULE.STAFF}`, formData)
}

export function updateStaffProfile(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'title', data.title);
    sharedHelper.appendIfNotNull(formData, 'phone_code', data.phoneCode);
    sharedHelper.appendIfNotNull(formData, 'phone_iso', data.phoneISO);
    sharedHelper.appendIfNotNull(formData, 'phone', data.phone);
    sharedHelper.appendIfNotNull(formData, 'address_1', data.address1);
    sharedHelper.appendIfNotNull(formData, 'postcode', data.postcode);
    sharedHelper.appendIfNotNull(formData, 'state', data.state);
    sharedHelper.appendIfNotNull(formData, 'city', data.city);
    sharedHelper.appendIfNotNull(formData, 'calendar_color', data.calendarColor);
    sharedHelper.appendIfNotNull(formData, 'remark', data.remark);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_first_name', data.emergencyContactPersonFirstName);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_last_name', data.emergencyContactPersonLastName);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_phone', data.emergencyContactPersonPhone);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_phone_code', data.emergencyContactPersonCode);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_phone_iso', data.emergencyContactPersonCodeISO);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_address_1', data.emergencyContactPersonAddress1);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_postcode', data.emergencyContactPersonPostcode);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_city', data.emergencyContactPersonCity);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_state', data.emergencyContactPersonState);
    sharedHelper.appendIfNotNull(formData, 'emergency_contact_person_email', data.emergencyContactPersonEmail);
    sharedHelper.appendIfNotNull(formData, 'birthday', data.birthday);
    sharedHelper.appendIfNotNull(formData, 'password', data.password);
    formData.append('_method', 'PUT');

    if (data.displayImage instanceof File) {
        formData.append('display_image', data.displayImage);
    }


    return apiHelper(API_URL).post(`/${MODULE.STAFF}/profile/update`, formData)
}